import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface IInputCheck {
    label?: string,
    name: string,
    type?: string,
    defaultValue?: string | number,
    placeholder?: string,
    control: any,
    error?: string,
    func: () => {},
    required?: boolean,
    column?: number,
    disabled?: boolean
}

export const JVInputCheck = (props: IInputCheck) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <div className="p-inputgroup">
                <Controller name={props.name} control={props.control} defaultValue={props.defaultValue ? props.defaultValue : ''} render={({ field, fieldState }) => (
                    <InputText {...field} disabled={props.disabled} type={props.type ? props.type : "text"} placeholder={props.placeholder} className={classNames({ 'p-invalid': fieldState.invalid })} />
                )} />
                <Button disabled={props.disabled} type="button" onClick={props.func} icon="pi pi-search" className="p-button-warning" />
            </div>
            <small className="p-error" >{props.error}</small>
        </div>
    )
}
